import { Suspense, useEffect } from 'react';
import CourseSettingsCard from '../../components/course-settings-card';
import EditCourse from '../../components/edit-course';
import { LoadingSpinner } from '../../components/ui/loading-spinner';
import { useParams, useNavigate } from 'react-router-dom';
import { useCourse } from '../../hooks/use-course';
import { useWorkspace } from '../../context/workspace-context';
import { useToast } from '../../components/ui/toast';

export default function CourseEditPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { currentWorkspace } = useWorkspace();
  const { showToast } = useToast();
  const courseId = parseInt(id!);

  const { isError } = useCourse(courseId, currentWorkspace?.id);

  useEffect(() => {
    if (isError) {
      showToast(
        'This course is no longer available. It may have been deleted by another admin.',
        'error',
      );
      navigate('/courses', { replace: true });
    }
  }, [isError, navigate, showToast]);

  return (
    <div className="space-y-4">
      <CourseSettingsCard key={currentWorkspace?.id} courseId={courseId} />
      <Suspense fallback={<LoadingSpinner />}>
        <EditCourse courseId={courseId} />
      </Suspense>
    </div>
  );
}
